import { httpClient } from "../../../shared/api";

function cleanQuery(query = {}) {
  const out = {};
  Object.entries(query).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    out[k] = v;
  });
  return out;
}

export const monitoringApi = {
  listAlerts(params = {}) {
    const qs = new URLSearchParams(cleanQuery(params)).toString();
    return httpClient.get(`/grafana/alerts${qs ? `?${qs}` : ""}`);
  },

  alertStats(params = {}) {
    const qs = new URLSearchParams(cleanQuery(params)).toString();
    return httpClient.get(`/grafana/alerts/stats${qs ? `?${qs}` : ""}`);
  },

  listReceivers() {
    return httpClient.get("/grafana/receivers");
  },

  backfillMappings() {
    return httpClient.post("/grafana/tenant-mappings/backfill", {});
  },

  listTenantMappings() {
    return httpClient.get("/grafana/tenant-mappings");
  },

  createTenantMapping(body) {
    return httpClient.post("/grafana/tenant-mappings", body);
  },

  deleteTenantMapping(id) {
    return httpClient.delete(`/grafana/tenant-mappings/${id}`);
  },
};
